
    var riot = require('riot')
    import { Option } from './gb-option';
riot.tag2('gb-option', '<a onclick="{onSelect}">{label}</a>', 'gb-option a,[data-is="gb-option"] a{ cursor: pointer; display: block; text-decoration: none; color: black; padding: 10px 12px; } gb-option a:hover,[data-is="gb-option"] a:hover{ background-color: #eee; }', '', function(opts) {
    this._mixin(Option);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/select/gb-option.tag.html